export const Authendpoint = {
  Signup: "auth/signup", // Direct signup (no OTP)
  LoginMobile: "auth/login-mobile", // Login with mobile + password
  Register: "auth/register",
  Login: "auth/register-login", //Jetx
  OtpVerify: "auth/verify-otp", //Jetx
  registerUserOtp_verify: "auth/register-otp-verify",
  resendOtp: "auth/resend-otp",
  forgotPassword: "auth/forgot-password",
  forgotPasswordOtpVerify: "auth/forget-password-otp-verify",
  resetPassword: "auth/reset-password",
};
export const Globalendpoints = {
  profile: "api/v1/user/profile",
  updateProfile: "api/v1/user/edit_profile",
  // walletBalance: "api/v1/user/wallet-balance",
  getallTickets: "api/v1/user/lottery_tickets",
  buyTickets: "api/v1/user/purchase_ticket",
  allTransaction: "api/v1/user/wallet",
  AddFundReq: "api/v1/user/add_fund_submit",
  fundReq: "api/v1/user/fund_requests",
  bankDetail: "api/v1/user/add_fund",
  getmyTickets: "api/v1/user/my_tickets",
  AddWithdraReq: "api/v1/user/withdraw_fund_submit",
  getWithdrawDetails: "api/v1/user/withdraw_fund",
  withdrawReq: "api/v1/user/withdraw_requests",
  getResultDetails: "api/v1/user/lotteryLeaderboard",
  // //////////////////////////////////////////////////////////////////////////////////////////////////
  betting: "color/betting",
  myBets: "color/my-games?type=",
  winningHistory: "color/fetch-game-history?type=",
  betHistory: "color/bet-history",
};
